import React, { FC } from 'react';
import { Row, Typography } from 'components';
import styles from './styles.module.scss';
import { Badge } from 'antd';

const { Text } = Typography;
export type StatusType = 'TODO' | 'IN_PROGRESS' | 'DONE' | 'REOPENED';

type StatusMapType = {
  label: string;
  color: string;
  dotColor: string;
};
export const STATUS_MAPPING: Record<StatusType, StatusMapType> = {
  TODO: {
    label: 'To Do',
    color: '#E6F0FF',
    dotColor: 'blue',
  },
  IN_PROGRESS: {
    label: 'In Progress',
    color: '#FFEEE0',
    dotColor: 'orange',
  },
  DONE: {
    label: 'Done',
    color: '#E0FAEC',
    dotColor: 'green',
  },
  REOPENED: {
    label: 'Reopened',
    color: '#fff2f0',
    dotColor: 'red',
  },
};

interface IStatusBadge {
  tooltip?: string;
  type: StatusType;
}

export const StatusBadge: FC<IStatusBadge> = React.memo((props) => {
  const { type: badgeType } = props;
  const type = badgeType || 'STANDARD';
  return (
    <Row
      style={{ borderColor: STATUS_MAPPING[type].dotColor }}
      className={`${styles.badge} ${styles[type]}`}
      align={'middle'}
    >
      {<Badge color={STATUS_MAPPING[type].dotColor} />}
      <Text style={{ color: STATUS_MAPPING[type].dotColor, fontSize: 12, fontWeight: 500 }}>
        {STATUS_MAPPING[type].label}
      </Text>
    </Row>
  );
});

export { LeadStatusBadge } from './LeadStatusBadge';
export { DealStatusBadge } from './DealStatusBadge';
export type { LeadStatusType } from './LeadStatusBadge';
export { SupplierStatusBadge } from './SupplierStatusBadge';
export { SupplierOfferStatusBadge } from './SupplierOfferStatusBadge';
export { PurchaseRequestStatusBadge } from './PurchaseRequestStatusBadge';
export { OrderStatusBadge, OrderItemStatusBadge } from './OrderStatusBadge';
export { PurchaseOrderItemStatusBadge, PurchaseOrderStatusBadge } from './PurchaseOrderStatusBadge';
